<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :isPrint="isPrint || !!postId"
                         @selectField="handleSelectField"/>

    <!-- 산업안전보건관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>안전·보건예산 항목</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table" :class="projectId===2? 'table-8':'table-5'" style="border-bottom:none;">
            <li class="header header-bg grid-row">
              <span>항목별</span>
              <span>예산</span>
              <span>당월 사용금액</span>
              <span>누계</span>
              <span>집행률</span>

              <span v-if="projectId===2">예산내역</span>
              <span v-if="projectId===2">집행내역</span>
              <span v-if="projectId===2">비고</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row" v-for="(item, index) in form.inputB" :key="item.label">
              <span class="header-bg">{{ item.label }}</span>
              <span>
                <span v-if="isPrint" class="print-input">{{ item.value1 }}</span>
                <ml-input v-else class="w-full" v-model=" item.value1" :readonly="board.readonly || !EnableSave"
                          @keyup="calculateB"/>
              </span>
              <span>
                <span v-if="isPrint" class="print-input">{{ item.value2 }}</span>
                <ml-input v-else class="w-full" v-model="item.value2" :readonly="board.readonly || !EnableSave"
                          @keyup="calculateB"/>
              </span>
              <span>
                <span v-if="isPrint" class="print-input">{{ item.value3 }}</span>
                <ml-input v-else class="w-full" v-model="item.value3" :readonly="true"/>
              </span>
              <span>
                <span v-if="isPrint" class="print-input">{{ item.value4 }}</span>
                <ml-input v-else class="w-full" v-model="item.value4" :readonly="true"/>
              </span>

              <span v-if="projectId===2">
                <span v-if="isPrint" class="print-input">{{ form.inputC[index].value1 }}</span>
                <ml-input v-else class="w-full" v-model="form.inputC[index].value1" :readonly="board.readonly" />
              </span>
              <span v-if="projectId===2">
                <span v-if="isPrint" class="print-input">{{ form.inputC[index].value2 }}</span>
                <ml-input v-else class="w-full" v-model="form.inputC[index].value2" :readonly="board.readonly" />
              </span>
              <span v-if="projectId===2">
                <span v-if="isPrint" class="print-input">{{ form.inputC[index].value3 }}</span>
                <ml-input v-else class="w-full" v-model="form.inputC[index].value3" :readonly="board.readonly" />
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row">
              <span class="header-bg">누계</span>
              <span>
                <span v-if="isPrint" class="print-input">{{ totalInputB.value1 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value1" :readonly="true"/>
              </span>
              <span>
                <span v-if="isPrint" class="print-input">{{ totalInputB.value2 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value2" :readonly="true"/>
              </span>
              <span>
                <span v-if="isPrint" class="print-input">{{ totalInputB.value3 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value3" :readonly="true"/>
              </span>
              <span>
                <span v-if="isPrint" class="print-input">{{ totalInputB.value4 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value4" :readonly="true"/>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'


export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo
    },
    totalInputB() {
      return this.computeInputTotal(this.form.inputB)
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(/*header*/) {
        this.initTotalB()
      }
    },
    value: {
      deep: true,
      async handler(value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form)
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key]
            }
          }

          this.calculateB()
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        value.summary = {
          안전보건예산_사업장명: [],
          안전보건예산_항목명: []
        }

        let totalBudget = 0
        for (const data of this.form.inputB) {
          totalBudget += Number(this.removeComma(`${data.value1}`))
          value.summary['안전보건예산_항목명'].push({
            [data.label]: Number(this.removeComma(`${data.value1}`))
          })
        }

        value.summary['안전보건예산_사업장명'].push({
          [this.form.stdInfo.field_name]: totalBudget
        })

        this.$emit('input', value)
      }
    },

    EnableSave: {
      immediate: true,
      handler() {
        this.$emit("EnableSave", this.EnableSave)
      }
    },
  },
  data() {
    return {
      EnableSave: true,
      oldForm: {},
      form: {
        total: {},
        stdInfo: {},
        fileList: [],
        totalB: [],
        inputB: [],
        inputC: [],
      }
    }
  },
  mounted() {

    if (this.form.inputB && this.form.inputB.length === 0) {
      if (this.projectId === 2) {
        this.form.inputB = [
          {label: '안전보건 인력 인건비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건 장비 구입비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '유해·위험요인 개선비', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '기타비용(특검, 교육 등)', value1: 0, value2: 0, value3: 0, value4: 0.0},
        ]
        this.form.totalB = [0, 0, 0, 0, 0]
        this.form.inputC = [
          {value1: '', value2: '', value3: '', value4: '',},
          {value1: '', value2: '', value3: '', value4: '',},
          {value1: '', value2: '', value3: '', value4: '',},
          {value1: '', value2: '', value3: '', value4: '',},
        ]
      } else {
        this.form.inputB = [
          {label: '방호장치, 안전장치 구입 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건 관련 물품 및 보호구 등 구입 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '위험설비 자동화 등 안전시설 개선 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '설비 및 시설물에 대한 안전점검 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건진단, 위탁 및 컨설팅 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '작업환경측정 및 특수건강진단 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '작업환경개선 및 근골격계 질환 예방 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '공상자 치료 및 응급구조 관련 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '건강관리실 및 건강증진실 운영 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건교육 훈련 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건관계자 외부교육 및 훈련 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건 포상 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건활동 촉진을 위한 캠페인 등 지원 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건조직 운영 및 재해예방 인력 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '협력업체 지원 비용', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '기타(산업안전보건관리비)', value1: 0, value2: 0, value3: 0, value4: 0.0},
        ]
        this.form.totalB = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    }

    this.initTotalB()
  },
  methods: {
    async initTotalB() {
      const postId = this.$route.params.postId
      if (!postId) {
        await this.loadListBoard()
        this.calculateB()
      }
    },
    handleSelectField() {
      this.initTotalB()
    },
    computeInputTotal(inputSet) {
      const inputTotal = {label: '누계', value1: 0, value2: 0, value3: 0, value4: 0}

      for (const inputB of inputSet) {
        inputTotal.value1 += Number(this.removeComma(inputB.value1) ? this.removeComma(inputB.value1) : 0)
        inputTotal.value2 += Number(this.removeComma(inputB.value2) ? this.removeComma(inputB.value2) : 0)
        inputTotal.value3 += Number(this.removeComma(inputB.value3) ? this.removeComma(inputB.value3) : 0)
      }

      // NaN 방지
      if (inputTotal.value1 > 0) {
        inputTotal.value4 = Math.floor(inputTotal.value3 * 10000.0 / inputTotal.value1) / 100
      } else {
        inputTotal.value4 = 0
      }

      inputTotal.value1 = this.comma(inputTotal.value1)
      inputTotal.value2 = this.comma(inputTotal.value2)
      inputTotal.value3 = this.comma(inputTotal.value3)

      this.form.total = inputTotal
      return inputTotal
    },
    async loadListBoard() {
      const projectId = this.$route.params.proj_id
      const boardId = 106
      const page = 1
      const perPage = 1000
      const dateTarget = 'content$header.full'
      const dateBegin = `${new Date().getFullYear()}-01-01`
      const dateEnd = `${new Date().getFullYear()}-12-31`
      const keyword = [`content$body.stdInfo.field_id*${this.form.stdInfo.field_id}`];

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        boardId,
        projectId,
        page,
        perPage,
        keyword,
        dateTarget,
        dateBegin,
        dateEnd
      })
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))]
      const totalB = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      if (rows.length > 0) {
        for (const data of rows) {
          const header = this.getHeader(data)
          const content = this.getContent(data)
          data.header = header;
          data.content = content;
          delete data.post_content;
        }

        // 검색된 데이터를, header.full 오름차순으로 정렬한다
        const sortedRows = rows.sort(function (a, b) {
          const x = new Date(a.header.full).getTime();
          const y = new Date(b.header.full).getTime();

          if (x < y) return -1;
          if (x > y) return 1;
          return 0;
        })

        // 작성된 글 중에서, 선택된 날짜와 가장 가까운 과거의 데이터를 추출한다
        let lastData;
        // 작성되 글 중에서, 선택된 날짜와 동일한 데이터를 추출한다
        let equalData;
        for (const data of sortedRows) {
          if (new Date(data.header.full).getTime() < new Date(this.header.full).getTime()) {
            lastData = data;
          }
          if (new Date(this.header.full).getTime() === new Date(data.header.full).getTime()) {
            equalData = data;
          }
        }

        // 작성된 글 중에서, 가장 마지막 글의 날짜를 확인한다
        const latestDate = sortedRows[sortedRows.length - 1].header.full;
        console.log(1)
        // 만약 현재 작성하는 날짜가, 이미 작성된 글보다 미래가 아닐 경우, 작성할 수 있으면 안된다
        if (new Date(this.header.full).getTime() <= new Date(latestDate).getTime()) {
          this.EnableSave = false;
          console.log(2)
          // 만약 해당 날짜에 작성된 데이터가 있다면, 해당 데이터를 화면에 표시한다
          if (equalData) {
            for (let i = 0; i < equalData.content.inputB.length; i++) {
              this.form.inputB[i].value1 = Number(this.removeComma(equalData.content.inputB[i].value1));
              this.form.inputB[i].value2 = Number(this.removeComma(equalData.content.inputB[i].value2));
              this.form.inputB[i].value3 = Number(this.removeComma(equalData.content.inputB[i].value3));
              this.form.inputB[i].value4 = Number(this.removeComma(equalData.content.inputB[i].value4));

              if (lastData) {
                totalB[i] = Number(this.removeComma(lastData.content.inputB[i].value3));
              } else {
                totalB[i] = 0;
              }
            }
          } else if (lastData) {
            // 만약 해당 날짜에 데이터가 없다면, 가장 최근 과거의 데이터를 화면에 표시한다 (당월 사용 금액은 데이터가 없으므로 0)
            for (let i = 0; i < lastData.content.inputB.length; i++) {
              this.form.inputB[i].value1 = Number(this.removeComma(lastData.content.inputB[i].value1));
              this.form.inputB[i].value2 = Number(this.removeComma(lastData.content.inputB[i].value2));
              this.form.inputB[i].value3 = Number(this.removeComma(lastData.content.inputB[i].value3));
              this.form.inputB[i].value4 = Number(this.removeComma(lastData.content.inputB[i].value4));
              totalB[i] = 0;
            }
          } else {
            for (let i = 0; i < this.form.inputB.length; i++) {
              this.form.inputB[i].value1 = 0;
              this.form.inputB[i].value2 = 0;
              this.form.inputB[i].value3 = 0;
              this.form.inputB[i].value4 = 0;
              totalB[i] = 0;
            }
          }
        } else {
          // 만약 새로운 날짜에 대한 데이터를 입력할 경우, 가장 최근 과거의 데이터를 화면에 표시한다
          this.EnableSave = true;

          if (lastData) {
            for (let i = 0; i < lastData.content.inputB.length; i++) {
              const inputB = lastData.content.inputB[i]
              this.form.inputB[i].value1 = Number(this.removeComma(lastData.content.inputB[i].value1));
              this.form.inputB[i].value2 = 0;
              totalB[i] = Number(this.removeComma(inputB.value3))
            }
          }
        }
        this.form.totalB = totalB
      } else {
        this.EnableSave = true;
      }

      if (!this.form.stdInfo.field_id) {
        this.EnableSave = false;
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },
    calculateB() {
      this.calculateInputs('inputB', 'totalB')
    },
    calculateInputs(inputName, totalName) {
      const inputSet = this.form[inputName]
      const list = []
      for (let i = 0; i < inputSet.length; i++) {
        const inputB = inputSet[i]

        // 콤마 삭제
        const value = {
          label: inputB.label,
          value1: this.removeComma(inputB.value1),
          value2: this.removeComma(inputB.value2),
        }

        // 누계사용금액 계산
        value.value3 = Number(this.removeComma(`${this.form[totalName][i]}`)) + Number(`${value.value2}`)

        // 집행률 계산
        if (Number(this.removeComma(`${value.value1}`)) > 0) {
          value.value4 = Math.floor(Number(this.removeComma(`${value.value3}`)) * 10000.0 / Number(this.removeComma(`${value.value1}`))) / 100
        } else {
          value.value4 = 0
        }
        list.push(value)
      }

      // 콤마 추가
      for (const inputB of list) {
        inputB.value1 = this.comma(inputB.value1)
        inputB.value2 = this.comma(inputB.value2)
        inputB.value3 = this.comma(inputB.value3)
        inputB.value4 = inputB.value4 ? inputB.value4 : '0'
      }
      this.form[inputName] = JSON.parse(JSON.stringify(list))
    },
    comma(str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    }
  },
}
</script>

<style scoped>

</style>
